class NtGridArticlesPager extends HTMLElement {
  connectedCallback() {
    this.grid = this.querySelector('.nt-grid-articles__grid');
    this.toggle = this.querySelector('.nt-grid-articles__toggle');
    if (!this.grid || !this.toggle) return;

    this.label = this.toggle.querySelector('[data-nt-toggle-label]');
    this.icon = this.toggle.querySelector('[data-nt-toggle-icon]');
    this.batchSize = parseInt(this.dataset.batchSize || '', 10) || 0;
    this.totalPages = parseInt(this.dataset.totalPages || '', 10) || 1;
    this.sectionId = this.dataset.sectionId || '';

    // Server mode: articles come from a blog and span several paginated pages, so
    // extra batches are fetched on demand instead of all being rendered upfront.
    this.serverMode = this.totalPages > 1 && this.sectionId !== '';
    this.loadedPages = 1;
    this.loading = false;

    if (this.serverMode) {
      this.baseCount = this.cards().length;
    } else {
      const total = this.cards().length;
      if (this.batchSize === 0 || total <= this.batchSize) return;
    }

    this.toggle.hidden = false;
    this.toggle.addEventListener('click', () => this.onClick());
    this.render();
  }

  cards() {
    return Array.from(this.grid.querySelectorAll('.nt-grid-articles__card'));
  }

  get allLoaded() {
    return this.serverMode ? this.loadedPages >= this.totalPages : this.expanded === true;
  }

  onClick() {
    if (this.loading) return;

    if (this.allLoaded) {
      this.collapse();
      return;
    }

    if (this.serverMode) {
      this.loadNextPage();
    } else {
      this.expanded = true;
      this.render();
    }
  }

  collapse() {
    if (this.serverMode) {
      this.cards()
        .slice(this.baseCount)
        .forEach((card) => card.remove());
      this.loadedPages = 1;
    } else {
      this.expanded = false;
    }
    this.render();
    this.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  async loadNextPage() {
    const nextPage = this.loadedPages + 1;
    this.loading = true;
    this.toggle.setAttribute('aria-busy', 'true');

    try {
      const url = `${window.location.pathname}?section_id=${encodeURIComponent(
        this.sectionId
      )}&page=${nextPage}`;
      const response = await fetch(url);
      if (!response.ok) throw new Error(`Request failed: ${response.status}`);

      const markup = await response.text();
      const parsed = new DOMParser().parseFromString(markup, 'text/html');
      const incoming = parsed.querySelectorAll('.nt-grid-articles__card');

      incoming.forEach((card) => this.grid.appendChild(card));
      this.loadedPages = nextPage;
    } catch (error) {
      console.error('[nt-grid-articles] could not load more articles', error);
      // Nothing more can be loaded reliably, so stop offering the action.
      this.totalPages = this.loadedPages;
    } finally {
      this.loading = false;
      this.toggle.removeAttribute('aria-busy');
      this.render();
    }
  }

  render() {
    if (!this.serverMode) {
      this.cards().forEach((card, index) => {
        card.hidden = !this.expanded && index >= this.batchSize;
      });
    }

    const collapsible = this.allLoaded;
    if (this.label) this.label.textContent = collapsible ? 'View Less' : 'View More';
    if (this.icon) this.icon.style.transform = collapsible ? 'rotate(180deg)' : 'rotate(0deg)';

    // In server mode page 1 is all there is, so there is nothing to toggle.
    if (this.serverMode && this.totalPages <= 1) this.toggle.hidden = true;
  }
}

customElements.define('nt-grid-articles-pager', NtGridArticlesPager);
